import { useTranslation } from 'react-i18next';
import PageHead from '@/components/shared/page-head';
import serverError from '@app/assets/images/server-error.svg';
import { Error } from '@/components/lightence/Error/Error';

export default function AccessDeniedPermission() {
  const { t } = useTranslation();

  return (
    <>
      <PageHead title={t('common.accessDenied')} />
      <Error
        img={serverError}
        msg={t('access-denied-permission.accessDenied')}
      />
    </>
  );
}
